import React from "react";
import { useSelector } from "react-redux";
import { headerMenuCountersSelector, userSelector } from "Utils/selectors";
import { HeaderVenueAdminDropDownMenu } from "./HeaderVenueAdminDropDownMenu";
import { HeaderMemberDropDownMenu } from "./HeaderMemberDropDownMenu";
import { HeaderAnonymousDropDownMenu } from "./HeaderAnonymousDropDownMenu";
import { HeaderEnterpriseAdminDropDownMenu } from "./HeaderEnterpriseAdminDropDownMenu";

interface HeaderDropDownMenuProps {
   redirectToMyLiquidSpaceAfterSignIn?: boolean;
   isEnterpriseManagment?: boolean,
}
export const HeaderDropDownMenu: React.FC<HeaderDropDownMenuProps> = function ({ redirectToMyLiquidSpaceAfterSignIn, isEnterpriseManagment }) {
   const user = useSelector(userSelector);
   const headerMenuCounters = useSelector(headerMenuCountersSelector);   
   
   return !user.isAuthenticated
      ? <HeaderAnonymousDropDownMenu redirectToMyLiquidSpaceAfterSignIn={redirectToMyLiquidSpaceAfterSignIn} />
      : user.isEnterpriseAccountAdmin && user.enterpriseAccountAdmin.length > 0
         ? <HeaderEnterpriseAdminDropDownMenu user={user} headerMenuCounters={headerMenuCounters} isEnterpriseManagment={isEnterpriseManagment} />
         : user.isVenueAdmin || user.isCalendarAdmin
            ? <HeaderVenueAdminDropDownMenu user={user} headerMenuCounters={headerMenuCounters} isEnterpriseManagment={isEnterpriseManagment}  />
            : <HeaderMemberDropDownMenu user={user} headerMenuCounters={headerMenuCounters} isEnterpriseManagment={isEnterpriseManagment} />;
}

